import { render, staticRenderFns } from "./GiftVouchers.vue?vue&type=template&id=45dc8610&scoped=true&"
import script from "./GiftVouchers.vue?vue&type=script&lang=js&"
export * from "./GiftVouchers.vue?vue&type=script&lang=js&"
import style0 from "./GiftVouchers.vue?vue&type=style&index=0&id=45dc8610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc8610",
  null
  
)

export default component.exports